<template>
    <b-modal :id="id" ref="modal-change-password" centered title="Change Password" hide-footer>        
       <form v-on:submit.prevent="changePassword">
            <div class="form-group">
                <label for="new-password" class="sr-only">Password</label>
                <input type="password" class="form-control" id="new-password" placeholder="Password" v-model="password" :class="{ 'is-invalid': $v.password.$error }"/>
                <div class="invalid-feedback" v-if="!$v.password.required">Field is required</div>
                <div class="invalid-feedback" v-if="!$v.password.minLength">Password must have at least {{ $v.password.$params.minLength.min }} letters.</div>
            </div>
            <div class="form-group">
                <label for="confirm-password" class="sr-only">Confirm password</label>
                <input type="password" class="form-control" id="confirm-password" placeholder="Confirm password" v-model="password_confirmation" :class="{ 'is-invalid': $v.password_confirmation.$error }"/>
                <div class="invalid-feedback" v-if="!$v.password_confirmation.required">Field is required</div>
                <div class="invalid-feedback" v-if="!$v.password_confirmation.sameAsPassword">Passwords must be identical.</div>
            </div>
            <div class="row-btn">
                <button type="submit" class="btn btn-primary">Confirm</button>
            </div>											
        </form>
    </b-modal>
</template>

<script>
import api from '../../http/api.js';
import { required, sameAs, minLength } from 'vuelidate/lib/validators'

export default {
    props: {
        id: String,
    },
    data: function () {
        return {
            password: '',
            password_confirmation: '',
        }
    },
    validations: {
        password: {
        required,
        minLength: minLength(8)
        },
        password_confirmation: {
        required,
        sameAsPassword: sameAs('password')
        }
    },
    methods: {
        changePassword: function(){
            this.$v.$touch()
                if (this.$v.$invalid) {
                    return false;
            }

            api.post('/v1/change-password', {
                password: this.password,
                password_confirmation: this.password_confirmation, 
            })
            .then(() => {
                this.state = {
                    password: '',
                    password_confirmation: '',
                }
                this.$refs['modal-change-password'].hide()
            }, () => {
                //console.log(error);
            });

        },
    }
}
</script>